// Lib-free timezone conversion via Intl offset-probe. Correct except across the
// rare DST-transition ambiguous/skipped hour, which is acceptable for expected
// check-in/out times. No dependency added (CLAUDE.md).
function offsetMs(instant: Date, tz: string): number {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: tz, hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const p: Record<string, string> = {};
  for (const part of dtf.formatToParts(instant)) p[part.type] = part.value;
  // The Intl.DateTimeFormat with year/month/day/hour/minute/second always
  // produces all six parts; the cast is safe.
  const asUTC = Date.UTC(
    +(p['year'] as string),
    +(p['month'] as string) - 1,
    +(p['day'] as string),
    +(p['hour'] as string),
    +(p['minute'] as string),
    +(p['second'] as string),
  );
  return asUTC - instant.getTime();
}

/** Wall-clock "YYYY-MM-DDTHH:mm" in tz → UTC ISO instant. */
export function zonedToUTC(local: string, tz: string): string {
  const guess = new Date(local + 'Z');         // treat wall-clock as if UTC
  const off = offsetMs(guess, tz);             // tz offset at that instant
  return new Date(guess.getTime() - off).toISOString();
}

/** UTC ISO instant → wall-clock "YYYY-MM-DDTHH:mm" in tz (datetime-local value). */
export function utcToZonedInput(iso: string, tz: string): string {
  const d = new Date(iso);
  const off = offsetMs(d, tz);
  return new Date(d.getTime() + off).toISOString().slice(0, 16);
}
